module.exports = __webpack_public_path__ + "static/media/mg-input-null-status.c9e77b50.svg";